const selectedSwatchPdp = document.querySelector('[data-section-type="product"] radio-swatch input:checked');
selectedSwatchPdp && selectedSwatchPdp.dispatchEvent(new Event('change'));

class ClearCart extends HTMLElement {
  constructor() {
    super();
    // Bind event handler
    this.addEventListener("click", (evt) => this.clearCart(evt));
  }

  async clearCart(evt) {
    try {
      // Clear cart using the clear.js endpoint
      const response = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      // Update cart state
      window.cart.getCart();
      this.cartDropdownIsOpen = true;
      
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  }
}

// Register custom element
customElements.define("clear-cart", ClearCart);